const money0 = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const num1 = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const dateFmt = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** 1 418 075 087 ₸ */
export function tenge(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return `${money0.format(v)} ₸`;
}

/** 1,42 млрд ₸ / 405,0 млн ₸ — для показателей на экране руководителя */
export function tengeShort(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  const abs = Math.abs(v);
  if (abs >= 1e9)
    return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(v / 1e9)} млрд ₸`;
  if (abs >= 1e6) return `${num1.format(v / 1e6)} млн ₸`;
  if (abs >= 1e3) return `${num1.format(v / 1e3)} тыс. ₸`;
  return tenge(v);
}

export function percent(v: number | null | undefined, digits = 1): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return `${new Intl.NumberFormat('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v)}%`;
}

/** Сегодня по часам человека (ГГГГ-ММ-ДД): не по UTC — с полуночи до 05:00 в Астане это был бы вчерашний день */
export function todayLocal(at: Date = new Date()): string {
  const m = String(at.getMonth() + 1).padStart(2, '0');
  const d = String(at.getDate()).padStart(2, '0');
  return `${at.getFullYear()}-${m}-${d}`;
}

export function date(v: string | Date | null | undefined): string {
  if (!v) return '—';
  return dateFmt.format(typeof v === 'string' ? new Date(v) : v);
}

export function dateTime(v: string | Date | null | undefined): string {
  if (!v) return '—';
  return dateTimeFmt.format(typeof v === 'string' ? new Date(v) : v);
}

/** «5 заявок», «1 заявка», «2 заявки» */
export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  const word =
    mod10 === 1 && mod100 !== 11
      ? one
      : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)
        ? few
        : many;
  return `${new Intl.NumberFormat('ru-RU').format(n)} ${word}`;
}

export function relative(v: string | null | undefined): string {
  if (!v) return 'никогда';
  const diff = Date.now() - new Date(v).getTime();
  const min = Math.round(diff / 60_000);
  if (min < 1) return 'только что';
  if (min < 60) return `${plural(min, 'минуту', 'минуты', 'минут')} назад`;
  const h = Math.round(min / 60);
  if (h < 24) return `${plural(h, 'час', 'часа', 'часов')} назад`;
  return date(v);
}
